import { render } from "./index.vue?vue&type=template&id=6d2209d8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=6d2209d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d2209d8"

export default script